export interface ChangelogEntry {
  version: string;
  date: string;
  title: string;
  changes: string[];
}

export const changelog: ChangelogEntry[] = [
  {
    version: 'v0.1.1',
    date: '2026-03-11',
    title: 'Stabilization',
    changes: [
      'Fixed Polymarket outcome ordering (B-002) — bidirectional word overlap fix',
      'Fixed kill switch P&L — now shows true P&L with average cost basis (B-005)',
      'Price unit runtime guards — assertCents() catches fractional-dollar mistakes before they reach orders',
      'Auth degradation visibility — amber status bar indicator + activity feed alerts when portfolio polling fails',
      'Fixed silent subscribe error in user stream WebSocket',
      '70 new tests across 9 files — all 6 critical coverage gaps now closed (1,542 total)',
    ],
  },
  {
    version: 'v0.1.0',
    date: '2026-03-10',
    title: 'Feedback Funnel + Git Reconciliation',
    changes: [
      'Feedback submit modal — report bugs/features with optional screenshots',
      'Feedback triage dashboard — admin-only, filter/update/annotate',
      'Issue tracker (Brendan) — password-gated bug tracking',
      'Deploy pipeline fixed — correct docroot discovery for g1.newbx.com',
      'Git reconciliation — merged 4 diverged commits, resolved 3 conflicts',
    ],
  },
  {
    version: 'v0.0.9',
    date: '2026-03-05',
    title: 'Must-Have Hardening',
    changes: [
      'Smart Relay trade pipeline wired end-to-end — volume + sweep detection now works via relay',
      'All 7 Domino must-haves verified LIVE against spec',
      '4 new test files — tradeEventBus, orderSortPreference, useTradeActivityBridge, useSweepDetection',
    ],
  },
  {
    version: 'v0.0.8',
    date: '2026-03-02',
    title: 'Phase 3: MM Tools + Deep Test',
    changes: [
      'Shard orders, smart pull, two-sided quoting, auto-follow mid, batch operations',
      '6 MM hotkeys, ultrawide layout, market heat map',
      'Deep test audit — 9 new test files, 7 failure buckets analyzed',
      'Feature checklist (94 items), sweep banner, kill-all activity event',
    ],
  },
  {
    version: 'v0.0.7',
    date: '2026-03-01',
    title: 'Fill Sound Detection (Stable)',
    changes: [
      'Belt-and-suspenders fill detection — HTTP polling catches fills even when WS is down',
      'AudioContext warmup on first gesture — polling-triggered fills can now play sound',
      'OrderMonitor starts immediately — no longer waits for WS user-stream',
    ],
  },
  {
    version: 'v0.0.5',
    date: '2026-02-28',
    title: 'Multi-Tenant Platform',
    changes: [
      'JWT + bcrypt auth system with refresh token rotation',
      'Trading rooms with WebSocket broadcast',
      'Admin panel — portfolio, trade log, stats, user management',
      'AES-256-GCM credential vault',
    ],
  },
  {
    version: 'v0.0.4',
    date: '2026-02-28',
    title: 'Remote Eyes',
    changes: [
      'Client-side error reporting — browser errors now visible in relay server logs',
      'Dedicated WSS server bypasses cPanel NGINX WebSocket blocking',
      'version.json generated at build time for reliable update notifications',
    ],
  },
  {
    version: 'v0.0.3',
    date: '2026-02-27',
    title: 'PM Bridge',
    changes: [
      'System architecture brief (L1/L2/L3 map for PM)',
      'Failure modes document (13 scenarios with recovery paths)',
      '3 seed ADRs: clean-room rebuild, monorepo, AI co-pilot',
      'PM mirror repo provisioned on ff.newbx.com',
      'One-way sync script for PM visibility',
    ],
  },
  {
    version: 'v0.0.2',
    date: '2026-02-27',
    title: 'Activity Rail + Enhanced Sounds',
    changes: [
      'Activity feed promoted to persistent right-side rail (replaces floating overlay)',
      'Resizable rail with drag handle (200–400px, persisted)',
      'Multi-voice synthesized sounds: warm fill, ka-ching first sale, whale splash',
      'First sale sound setting with toggle in sound settings panel',
      'AI context annotations on 15 money-path files',
    ],
  },
  {
    version: 'v0.0.1',
    date: '2026-02-26',
    title: 'Genesis',
    changes: [
      'Clean-room rebuild from Galactus reference',
      'Pruned views engine, orphaned files, speculative libs (-8,700 lines)',
      'Core trading terminal: Kalshi + Polymarket integration',
      'Market explorer, position tracker, order management',
      'Value dashboard with multi-sport streaming',
      'MM defense system, perf tracker, diagnostics',
      '687 dashboard tests, 72 relay tests',
    ],
  },
];

export const CURRENT_VERSION = changelog[0].version;
